import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

/** The routed-page wrapper: a `space-y-6` stack with no width cap (DESIGN.md §1). */
export function PageShell({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={twMerge('space-y-6', className)}>{children}</div>;
}
